import { useCallback, useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { clientesService, type ClienteAgradaDetail } from '@/services/clientesService'
import type { ClienteAgradaTabId } from '@/components/ClientesAgrada/clienteAgradaDetailTabsConfig'

const VALID_TABS: ClienteAgradaTabId[] = [
  'cadastro',
  'historico',
  'servicos',
  'deals',
  'projetos',
  'chamados',
]

export function useClienteAgradaDetailPage() {
  const { id } = useParams<{ id: string }>()
  const [searchParams, setSearchParams] = useSearchParams()
  const rawTab = searchParams.get('tab') as ClienteAgradaTabId | null
  const tab: ClienteAgradaTabId = rawTab && VALID_TABS.includes(rawTab) ? rawTab : 'cadastro'
  const highlightProjectId = searchParams.get('projeto')

  const [detail, setDetail] = useState<ClienteAgradaDetail | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const setTab = useCallback(
    (next: ClienteAgradaTabId) => {
      setSearchParams((prev) => {
        const p = new URLSearchParams(prev)
        p.set('tab', next)
        return p
      })
    },
    [setSearchParams],
  )

  const reload = useCallback(async () => {
    if (!id) return
    setLoading(true)
    setError(null)
    try {
      const data = await clientesService.getById(id)
      setDetail(data)
    } catch {
      setDetail(null)
      setError('Cliente não encontrado ou sem acesso.')
    } finally {
      setLoading(false)
    }
  }, [id])

  useEffect(() => {
    void reload()
  }, [reload])

  return {
    id,
    tab,
    setTab,
    highlightProjectId,
    detail,
    loading,
    error,
    reload,
  }
}
